import axios from 'axios';
import { Product } from "../types";


interface QuickAddProduct {
    product_id: number;
    product_name: string;
    image_url: string;
    admin_id?: number;
    created_at: string;
    updated_at: string;
  }

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.thunderbirdsmoke.net';

// const authHeader = () => {
//     const token = localStorage.getItem('authToken'); // Retrieve the token from localStorage
//     if (!token) {
//       throw new Error('No auth token found');
//     }
//     return { Authorization: `Bearer ${token}` };
//   };


  
  
  const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.thunderbirdsmoke.net";
  
  const authHeader = () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No auth token found");
    }
    return { Authorization: `Bearer ${token}` };
  };
  
  // Fetch all Quick Add products and map to Product type
  export const fetchQuickAddProducts = async (): Promise<Product[]> => {
    const response = await axios.get(`${API_BASE_URL}/quick-add`, {
      headers: authHeader(),
    });
  
    console.log("📢 Quick Add API Response:", response.data); // ✅ Debugging log
  
    return response.data.map((product: any) => ({
      id: product.id || product.product_id,
      product_id: product.product_id,
      sku: product.sku || "No SKU",
      name: product.name || product.product_name || "Unnamed Product",
      product_name: product.product_name || "Unnamed Product",
      price: product.price || 0,
      image_url: product.image_url || product.product_image || "/placeholder-image.png", // ✅ Fix here
      category_id: product.category_id || null,
      category_name: product.category_name || "Uncategorized",
      variants: product.variants || [],
    }));
  };
  
  
  

// Add a product to Quick Add
export const addQuickAddProduct = async (productId: number): Promise<void> => {
  await axios.post(
    `${API_BASE_URL}/quick-add`,
    { product_id: productId },
    {
      headers: authHeader(),
    }
  );
};

// Remove a product from Quick Add
export const removeQuickAddProduct = async (productId: number): Promise<void> => {
  await axios.delete(`${API_BASE_URL}/quick-add/${productId}`, {
    headers: authHeader(),
  });
};

